module.exports = __webpack_public_path__ + "media/images/country_flags/sh-aa61426a8530eec982a2a75b469429b4.png";